import { render, staticRenderFns } from "./OrderbookChannel.vue?vue&type=template&id=4886b105&"
import script from "./OrderbookChannel.vue?vue&type=script&lang=js&"
export * from "./OrderbookChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports